module.exports = __webpack_public_path__ + "static/media/hereditary@2x.150067e9.png";